import { Accordion, AccordionTab } from 'primereact/accordion';

import { Advertiser } from '@features/users/adminPanel/components/Advertisers/components/Advertiser/Advertiser.tsx';
import { Header } from '@features/users/adminPanel/components/Advertisers/components/Header/Header.tsx';
import { EmptyState } from '@features/users/adminPanel/components/EmptyState/EmptyState.tsx';
import { AdvertisersCollection } from '@features/users/adminPanel/types/advertisers.types.ts';

interface AdvertisersProps {
  data: AdvertisersCollection;
}

export function Advertisers({ data }: AdvertisersProps) {
  const isAdvertisersCollectionEmpty = data.length === 0;

  if (isAdvertisersCollectionEmpty) {
    return <EmptyState />;
  }

  return (
    <Accordion>
      {data.map((advertiser) => (
        <AccordionTab
          header={<Header status={advertiser.status} name={advertiser.name} vatNumber={advertiser.vatNumber} />}
          key={advertiser.id}
        >
          <Advertiser
            id={advertiser.id}
            name={advertiser.name}
            status={advertiser.status}
            vatNumber={advertiser.vatNumber}
            invoicingEmail={advertiser.invoicingEmail}
          />
        </AccordionTab>
      ))}
    </Accordion>
  );
}
